import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Brain, Mail, Lock, AlertCircle } from 'lucide-react';
import { api } from '../../utils/api';
import { toast } from 'sonner';

export const AdminLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    
    try {
      await api.auth.login(email, password);
      // Con Supabase ya no necesitamos manejar el localStorage manualmente en la mayoría de los casos
      // ya que el cliente de Supabase lo gestiona automáticamente.
      toast.success('¡Bienvenido!');
      navigate('/admin/dashboard');
    } catch (error) {
      console.error('Login error:', error);
      setError('Credenciales inválidas. Verifica tu email y contraseña.');
      toast.error('Error al iniciar sesión');
    } finally {
      setLoading(false);
    }
  };  return (
    <div className="min-h-screen flex items-center justify-center bg-black selection:bg-[#C6FF00] selection:text-black overflow-hidden" data-testid="admin-login-page">
      <div className="absolute inset-0 grid-bg opacity-30"></div>
      <div className="absolute inset-0 mesh-gradient opacity-20"></div>
      
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="relative w-full max-w-sm mx-4 z-10"
      >
        <div className="bg-[#050505] rounded-[3rem] p-10 sm:p-14 border border-white/5 shadow-[0_40px_100px_rgba(0,0,0,0.8)]">
          <div className="text-center mb-12">
            <div className="flex justify-center mb-8">
              <div className="w-16 h-16 bg-white/5 rounded-2xl flex items-center justify-center border border-white/10 relative group">
                <div className="absolute inset-0 bg-[#C6FF00] blur-2xl opacity-0 group-hover:opacity-20 transition-opacity"></div>
                <Brain className="w-8 h-8 text-white relative transition-colors group-hover:text-[#C6FF00]" />
              </div>
            </div>
            <h1 className="text-xs font-black uppercase tracking-[0.4em] text-[#C6FF00] mb-4" data-testid="login-title">Security Gateway</h1>
            <p className="text-white/30 text-xs font-medium uppercase tracking-widest">Authorized Access Only</p>
          </div>
          
          {error && (
            <div className="mb-8 p-4 rounded-2xl bg-red-500/10 border border-red-500/20 flex items-start space-x-3" data-testid="login-error">
              <AlertCircle className="w-4 h-4 text-red-500 flex-shrink-0 mt-0.5" />
              <p className="text-red-500 text-[10px] uppercase font-black tracking-widest leading-relaxed">{error}</p>
            </div>
          )}
          
          <form onSubmit={handleSubmit} className="space-y-8">
            <div className="space-y-3">
              <label htmlFor="email" className="block text-[10px] font-black uppercase tracking-widest text-white/20 ml-4">
                Identifier
              </label>
              <div className="relative">
                <Mail className="absolute left-6 top-1/2 -translate-y-1/2 w-4 h-4 text-white/20" />
                <input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full pl-14 pr-6 py-4 rounded-full bg-white/[0.02] border border-white/5 focus:border-[#C6FF00]/30 focus:outline-none transition-all text-sm font-bold tracking-tight text-white placeholder:text-white/10"
                  placeholder="name@nexus.io"
                  required
                  data-testid="login-email-input"
                />
              </div>
            </div>
            
            <div className="space-y-3">
              <label htmlFor="password" className="block text-[10px] font-black uppercase tracking-widest text-white/20 ml-4">
                Access Code
              </label>
              <div className="relative">
                <Lock className="absolute left-6 top-1/2 -translate-y-1/2 w-4 h-4 text-white/20" />
                <input
                  id="password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full pl-14 pr-6 py-4 rounded-full bg-white/[0.02] border border-white/5 focus:border-[#C6FF00]/30 focus:outline-none transition-all text-sm font-bold tracking-tight text-white placeholder:text-white/10"
                  placeholder="••••••••"
                  required
                  data-testid="login-password-input"
                />
              </div>
            </div>
            
            <button
              type="submit"
              disabled={loading}
              className="w-full py-5 rounded-full bg-[#C6FF00] text-black font-black uppercase tracking-[0.2em] text-xs hover:scale-105 transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed shadow-[0_20px_40px_rgba(198,255,0,0.15)]"
              data-testid="login-submit-button"
            >
              {loading ? 'Initializing...' : 'Decrypt & Entrer'}
            </button>
          </form>
          
          <div className="mt-12 text-center text-[10px] font-black uppercase tracking-[0.2em] text-white/10">
            <p>Protocol: Build Brains / Alpha 1.0</p>
          </div>
        </div>
      </motion.div>
    </div>
  );
};